import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/config/queries';
import { supabase } from '@/integrations/supabase/client';
import { createLogger } from '@/lib/structuredLogger';

const logger = createLogger('LatestCheckin');

export interface LatestCheckin {
  weekly_win: string | null;
  energy_level: number | null;
  stress_management_score: number | null;
  sleep_quality_subjective: number | null;
  digestion_issues: string[] | null;
  created_at: string;
}

export function useLatestCheckin(userId?: string) {
  return useQuery({
    queryKey: QUERY_KEYS.LATEST_CHECKIN(userId ?? ''),
    queryFn: async () => {
      if (!userId) return null;

      const { data, error } = await supabase
        .from('weekly_checkins')
        .select(
          'weekly_win, energy_level, stress_management_score, sleep_quality_subjective, digestion_issues, created_at',
        )
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) {
        logger.error('Error fetching latest checkin', error);
        return null;
      }

      return data as LatestCheckin | null;
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 60,
  });
}
